export default __webpack_public_path__ + "static/media/SD-3.a6b606ee.jpg";